export const approveSurveyService = (fetch) => async (survey) => {
  try {
    const response = await fetch({
      url: "/api/v2/update/approvesurvey",
      method: "put",
      body: survey,
      permission: "1"
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error al intentar aprovar la encuesta"
    );
  }
};
